import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const CofiBedrockAgentAws = async (
    requestId,
    userId,
    role,
    prompt,
    sectorCode,
    regionCode,
    confidence
  ) => {
    const sessionData = getSessionData();
    try {
      const data = JSON.stringify({
        svc: "cofi",
        pid: "CofiBedrockAgentAws",
        dat: {
            requestId: requestId,
            userId: userId,
            role: role,
            prompt: prompt,
            sectorCode: sectorCode,
            regionCode: regionCode,
            confidence: confidence,
          ...sessionData
        },
      });
        
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      const sessionActive = checkSessionIsActive(response.data);
      if (!sessionActive) {
        resetSession();
      }
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const CofiUploadToS3 = async (
  requestId,
  userId,
  fileName,
  fileContent,
  regionCode,
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "cofi",
      pid: "CofiUploadToS3",
      dat: {
          requestId: requestId,
          userId: userId,
          fileName: fileName,
          fileContent: fileContent,
          regionCode: regionCode,
        ...sessionData
      },
    });
      
    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const CofiViewFromS3 = async (
  requestId,
  userId
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "cofi",
      pid: "CofiViewFromS3",
      dat: {
          requestId: requestId,
          userId: userId,
        ...sessionData
      },
    });
      
    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const CofiDeleteFromS3 = async (
  requestId,
  userId,
  s3Key
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "cofi",
      pid: "CofiDeleteFromS3",
      dat: {
          requestId: requestId,
          userId: userId,
          s3Key: s3Key,
        ...sessionData
      },
    });
      
    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};